module.exports = __webpack_public_path__ + "../resources/img/ic_re_myhome_dr.c8fff120.svg";